import { nFormatter } from "./nFormatter";

export function formatNumber(value, decimals = 2, nify = true) {
  if (value > 10000 && nify) {
    return nFormatter(value, decimals);
  }

  if (typeof value === 'string') {
    value = parseFloat(value);
  }

  if (typeof value === 'undefined' || value === null || typeof value !== 'number' || isNaN(value)) {
    return '--';
  }

  value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);

  if (value < 1000 && value > -1000) {
    return value.toString();
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
